import axios from "axios";

const axiosInstance = axios.create({
  //  baseURL: 'http://127.0.0.1:8000/api/v3/',
  baseURL: 'https://sys.boostceramic.ca/api/v3/',
  redirect: "follow"
});

export default axiosInstance;
